/**
 * GA4 カスタムイベント（フォーム送信・LINE・電話）
 *
 * 読み込み条件: テーマ設定「GA4 測定 ID」が設定されている場合のみ layout/theme.liquid から読み込まれる。
 * ページビュー・商品・購入イベントは Google & YouTube アプリ連携側で送信するため、
 * このファイルでは以下だけを送信する:
 *   - generate_lead: 問い合わせフォーム（{% form 'contact' %}）の送信
 *   - line_click: LINE 導線（lin.ee / line.me / /pages/line-assessment へのリンク）
 *   - phone_click: tel: リンク
 *
 * イベント名は GA4 管理画面でコンバージョン登録する（手順: docs/ga4-tracking-setup.md）。
 */
(function () {
  'use strict';

  if (typeof window.dataLayer === 'undefined') {
    window.dataLayer = [];
  }

  function track(eventName, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params || {});
    }
  }

  // 電話発信
  document.addEventListener('click', function (event) {
    var anchor = event.target.closest('a[href^="tel:"]');
    if (anchor) {
      track('phone_click');
    }
  });

  // LINE 導線（外部 LINE リンクと /pages/line-assessment への CTA）
  document.addEventListener('click', function (event) {
    var anchor = event.target.closest('a[href*="lin.ee"], a[href*="line.me"], a[href*="/pages/line-assessment"]');
    if (anchor) {
      track('line_click');
    }
  });

  // 問い合わせフォーム送信（{% form 'contact' %} は action が /contact になる）
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action || form.action.indexOf('/contact') === -1) {
      return;
    }

    var typeSelect = form.querySelector('select[name="contact[お問い合わせ区分]"]');
    var typeValue = typeSelect ? typeSelect.value : '';
    var formType = 'general';

    if (typeValue === '宅配買取のお申し込み') {
      formType = 'purchase';
    } else if (typeValue === '委託販売のご相談') {
      formType = 'consignment';
    }

    track('generate_lead', {
      form_type: formType,
      page_path: window.location.pathname
    });
  });
})();